export default {
      id: "ic_eye_close-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_eye_close-usage",
      toString: function () {
        return this.url;
      }
    }